import React from "react";
import { SegFlags, translate } from "../../providers";
import { DocumentCenterTour, SearchTour, ReviewReaderTour } from "./product-tours";
import { NavUtils } from "../../../navigation";

export const ESSENTIAL_TOURS = {
	DOCUMENTS: {
		id: 1,
		flags: [SegFlags.DOCUMENT_CENTER, SegFlags.PRECEDENCE],
		name: translate("common:product-tour.essential.documents"),
		locations: ["/projects/:projectId/documents"],
		redirection: (projectId) => NavUtils.goToDocumentCenter(projectId),
		tooltipText: translate("common:product-tour.menu.restriction.project"),
		component: <DocumentCenterTour />,
		prev: null,
		next: null,
		icon: "faFile",
	},
	SEARCH: {
		id: 2,
		flags: [SegFlags.SMART_SEARCH],
		name: translate("common:product-tour.essential.search"),
		locations: ["/projects/:projectId/search/my-search/"],
		redirection: (projectId) => NavUtils.goToMySearch(projectId),
		tooltipText: translate("common:product-tour.menu.restriction.project"),
		component: <SearchTour />,
		prev: null,
		next: null,
		icon: "faSearch",
	},
	MY_REVIEW_NAV_COM: {
		id: 3,
		flags: [SegFlags.SMART_REVIEW],
		name: translate("common:product-tour.essential.review"),
		locations: ["/projects/:projectId/review/my-review/*"],
		redirection: (projectId) => NavUtils.goToSmartReview(projectId),
		tooltipText: translate("common:product-tour.menu.restriction.project"),
		component: <ReviewReaderTour />,
		prev: null,
		next: null,
		icon: "faPen",
	},
};
